__turbopack_context__.v({
  "BasePage": "UIDM8W_BasePage",
  "Footer": "UIDM8W_Footer",
  "MainContent": "UIDM8W_MainContent",
  "NavDesktop": "UIDM8W_NavDesktop",
  "NavMobile": "UIDM8W_NavMobile",
});
